import React, {useRef, useEffect, useState } from 'react';
import { ChevronDown } from "lucide-react";
import { motion } from 'framer-motion';
import { Link } from "react-router-dom";

import ww from "../assets/WW.webp";

import tick from "../assets/Tick.svg";
import wh from "../assets/WH.png";
import l from "../assets/L.png";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";
import r from "../assets/R.png";
import g1 from "../assets/G1.png";
import g2 from "../assets/G2.png";
import g3 from "../assets/G3.png";
import g4 from "../assets/G4.png";
import g5 from "../assets/G5.png";
import g6 from "../assets/G6.png";
import devIcon from "../assets/F1.png";
import skillsIcon from "../assets/F2.png";
import techIcon from "../assets/F3.png";
import competitiveIcon from "../assets/F4.png";

import { Helmet } from "react-helmet";

import { useNavigate } from 'react-router-dom'; 
import { toast, ToastContainer } from "react-toastify";
 
const Health = () => {
 const words = ["Today", "Tomorrow"];
  const [index, setIndex] = useState(0);

    useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000); // changes every 3s
    return () => clearInterval(timer);
  }, []);
   const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
 
   const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api.app.mawalog.com/v1.2/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
 
    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
 
    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
 
    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");
 
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);
 
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });
 
    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);
 
  /* -- reload button click ------------------------------------------------------- */
  // const handleReload = () => {
  //   fetch("https://api.app.mawalog.com/v1.2/website")
  //     .then((response) => response.json())
  //     .then((json) => {
  //       setData(json.data.captcha_code);
  //       setSessionid(json.data.session_id);
  //       setToken(json.data.token);
  //     })
  //     .catch((error) => console.error("Error fetching data:", error));
  // };
  //   const handleSubscribe = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://api.app.mawalog.com/v1.2/newsletter",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CSRF-TOKEN": token,
  //         },
  //         body: JSON.stringify({
  //           session_id: sessionid,
  //           captcha: userCaptcha,
  //           email: email,
  //           type: "Mawalog",
  //         }),
  //       }
  //     );
 
  //     const result = await response.json();
  //     console.log("Response:", userCaptcha, " ", data);
  //     setEmail("");
  //    setUserCaptcha("");
  //     toast(result.message);
  //   } catch (error) {
  //     console.error("Error sending request:", error);
  //   }
  // };
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
  
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
     const [isServicesOpen, setIsServicesOpen] = useState(false);
     const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
     const [isCompanyOpen, setIsCompanyOpen] = useState(false);
   
     const toggleMobileMenu = () => {
       setIsMobileMenuOpen(!isMobileMenuOpen);
     };
   
     const toggleServicesDropdown = () => {
       setIsServicesOpen(!isServicesOpen);
     };
   
     const toggleIndustriesDropdown = () => {
       setIsIndustriesOpen(!isIndustriesOpen);
     };
   
     const toggleCompanyDropdown = () => {
       setIsCompanyOpen(!isCompanyOpen);
     };
      const [word, setWord] = useState('Today');

  useEffect(() => {
    const interval = setInterval(() => {
      setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
    }, 2000);
    return () => clearInterval(interval);
  }, []);



  const healthWords = ['Today', 'tomorrow']; // or any words you want
const [healthIndex, setHealthIndex] = useState(0);
const [healthFade, setHealthFade] = useState(true);

useEffect(() => {
  const interval = setInterval(() => {
    setHealthFade(false); // fade out
    setTimeout(() => {
      setHealthIndex(i => (i + 1) % healthWords.length);
      setHealthFade(true); // fade in
    }, 500);
  }, 2000);

  return () => clearInterval(interval);
}, []);

const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };
  const features = [
  {
    text: "Revolutionizes healthcare training and recruitment.",
    width: 350,
    height: 150,
  },
  {
    text: "Cutting-edge tools ensure smooth hiring and professional growth.",
    width: 348,
    height: 240,
  },
  {
    text: "Streamlined hiring process reduces time and effort.",
    width: 280,
    height: 100,
  },
  {
    text: "Continuous learning opportunities for career advancement.",
    width: 368,
    height: 220,
  },
  {
    text: "Enhanced effectiveness of healthcare operations.",
    width: 348,
    height: 200,
  },
  {
    text: "Empowering providers with scalable tools for efficiency.",
    width: 328,
    height: 210,
  },
];

const FeatureCard = ({ icon, title, description }) => (
  <div className="bg-green-50 rounded-2xl p-6 min-w-[300px] max-w-sm flex-shrink-0">
    <div className="mb-4">
      <img src={icon} alt="" className="h-10 w-10" />
    </div>
    <h3 className="font-semibold text-lg text-gray-900 mb-2">{title}</h3>
    <p className="text-sm text-gray-700 leading-relaxed">{description}</p>
  </div>
);

  const featuress = [
    {
      icon: g1,
      title: "Streamlined hiring process",
      description:
    "Our platform lets healthcare providers post jobs, review applications, and schedule interviews in one place, saving time and effort."    },
    {
      icon: g2,
      title: "Empowering healthcare institutions",
      description:
    "We give healthcare institutions secure logins to manage hiring easily, ensuring qualified staff deliver top-quality patient care."    },
    {
      icon: g3,
      title: "Flexible learning options",
      description:
        "We offer flexible learning options so healthcare professionals can balance ongoing education with their work schedules."
    },
    {
      icon: g4,
      title: "Comprehensive training programs",
      description:
        "We provides training programs to upskill healthcare professionals, offering industry-relevant courses accessible directly through our website."
    },
    {
      icon: g5,
      title: "Innovative recurring bookings",
      description:
        "Healthcare providers can efficiently schedule staff for specific shifts, ensuring optimal coverage and resource use to meet evolving healthcare demands."
    },
    {
      icon:g6,
      title: "Efficient financial transactions",
      description:
        "Our platform streamlines financial transactions with weekly salary payouts to medical professionals, ensuring transparency, consistency & smooth operations for all users."
    }
  ];




  
const featuresss = [
  {
    title: "Comprehensive professional development",
    description:
      "Quick changes taking place in the healthcare industry. Our platform provides a large selection of Continuing Professional Development (CPD) courses and seminars to keep professionals up to date on the most recent innovations and best practices.",
    icon: devIcon,
    bg: "bg-[#C9F2FF]",
  },
  {
    title: "Enhancement of skills",
    description:
      "These programs aim to guarantee that healthcare providers can deliver excellent care by updating knowledge and improving skills. Professionals may stay up to date on the newest developments in healthcare technology and trends by enrolling in our CPD courses.",
    icon: skillsIcon,
    bg: "bg-[#F1E3FF]",
  },
  {
    title: "Cutting-edge technologies",
    description:
      "We equip providers with access to innovative healthcare technologies, improving diagnostics, treatment plans, and operational workflows that directly impact care delivery.",
    icon: techIcon,
    bg: "bg-[#E2FFE2]",
  },
  {
    title: "Remaining competitive",
    description:
      "By investing in continuous learning and advanced tools, healthcare providers maintain a competitive edge in the ever-evolving medical industry and meet evolving patient needs.",
    icon: competitiveIcon,
    bg: "bg-[#FFF5D0]",
  },
];


const FeatureCarrd = ({ icon, bg, title, description }) => (
  <div className="bg-white shadow-md rounded-xl p-6 font-poppins">
    <div className="w-12 h-12 flex items-center justify-center rounded-md mb-4" style={{ backgroundColor: bg }}>
      <img src={icon} alt={title} className="w-20 h-30 mr-10 md-30" />
    </div>
    <h3 className="font-semibold text-[15px] text-[#1c1c1c] mb-2 text-left">{title}</h3>
    <p className="text-[12px] text-[#3d3d3d] leading-relaxed text-left">{description}</p>
  </div>
);

const columns = 3; // number of columns in your grid

 const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

const ffeatures = [
  {
    text: "Revolutionizes healthcare training and recruitment.",
    width: 250,
    height: 190,
  },
  {
    text: "Cutting-edge tools ensure smooth hiring and professional growth.",
    width: 348,
    height: 150,
  },
  {
    text: "Streamlined hiring process reduces time and effort.",
    width: 275,
    height: 180,
  },
  {
    text: "Continuous learning opportunities for career advancement.",
    width: 368,
    height: 180,
  },
 {
    text: "Enhanced effectiveness of healthcare operations.",
    width: 348,
    height: 180,
    lift: true, // 👈 Mark this card to move up
  },
  {
    text: "Empowering providers with scalable tools for efficiency.",
    width: 328,
    height: 180,
  },
];


const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};
const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

   // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
    const handleSubscribe = async (e) => {
  e?.preventDefault?.();

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!submail) {
    toast("Please enter an email address");
    return;
  }

  if (!emailRegex.test(submail)) {
    toast("Please enter a valid email address");
    return;
  }

  if (!newsletterUserCaptcha) {
    toast("Please enter the captcha");
    return;
  }

  try {
    const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
      },
      body: JSON.stringify({
        session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
        captcha: newsletterUserCaptcha, // use newsletter captcha input
        email: submail,
        type: "Mawalog",
      }),
    });

    const result = await res.json();

    // On success clear inputs and reload captcha
    if (res.ok) {
      setSubmail("");
      setNewsletterUserCaptcha("");
      fetchNewsletterCaptcha();
    }

    toast(result.message || "Subscription response received");
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    toast("Subscription failed. Please try again.");
  }
};

  return (
    <div >
     
     <Helmet>
        <title>Innovative Healthcare Solutions | Streamlined Hiring & Professional Development</title>
        <meta name="description" content="Streamline recruitment, empower staff with professional development, leverage cutting-edge technologies, and improve patient care efficiency through automated processes and data-driven insights."/>
        <meta name="keywords" content=" LENTERA healthcare services, digital healthcare tools, hospital workflow management, healthcare training programs."/>
      </Helmet>
     <section className="bg-[#FFF6EF] font-poppins">
      <div className="mx-auto flex max-w-7xl flex-col-reverse items-center gap-8 px-4 py-16 md:flex-row">
        {/* Text Section */}
        <div className="w-full md:w-6/12 md:ml-10 text-center md:text-left">
          <p className="uppercase text-sm text-[#1c1c1c] mb-2 tracking-wide">
            Healthcare
          </p>

          <h2 className="text-3xl md:text-4xl font-bold text-[#1c1c1c] leading-snug mb-2">
            Healthcare with innovative <br /> solutions for a healthier
          

            of{" "}
            <span className="inline-block h-[60px] overflow-hidden relative align-middle">
              <div
                className="transition-transform duration-700 ease-in-out"
                style={{
                  transform: `translateY(-${index * 60}px)`,
                }}
              >
                {words.map((word, i) => (
                  <div
                    key={i}
                    className="h-[60px] text-[#F7BC2C] flex items-center text-[40px] sm:text-[44px] lg:text-[48px] font-bold"
                  >
                    {word}
                  </div>
                ))}
              </div>
            </span>
          </h2>

          <p className="max-w-xl mx-auto md:mx-0 text-[15px] leading-relaxed text-gray-700">
            The approach allows institutions to streamline administrative tasks,
            improve data management, and enhance student learning experiences.
          </p>
        </div>

        {/* Image Section */}
        <div className="w-full md:w-6/12 flex justify-center">
          <img
            src={ww}
            alt="Healthcare Illustration"
            className="w-4/5 md:w-[60%] lg:w-[70%]"
          />
        </div>
      </div>
    </section>

    
<section className="px-4 py-8 mt-10">
  <div className="max-w-screen-xl mx-auto">
    <div className="bg-black text-white rounded-[50px] px-6 md:px-10 py-8 flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8">
      
      {/* Title */}
      <h2 className="text-2xl text-white md:text-3xl font-bold 
        bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-500 
        bg-[length:200%_200%] bg-clip-text text-transparent 
        animate-gradient"
      >
        Overview
      </h2>

      {/* Divider */}
      <div className="hidden md:block w-px h-10 bg-white" />

      {/* Description */}
     <p className="text-[16px] font-[400] leading-[28px]  text-[white]">
  Educational institutions can take advantage of advanced functionality,
  automate processes, and offer <br className="hidden sm:block" /> seamless cross-platform access to educational
  resources by integrating specialized services like content <br className="hidden sm:block" />
  repositories, learning management systems, and student information systems.
</p>


    </div>
  </div>
</section>


  <section className="bg-white font-poppins px-4 md:px-16 py-16">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
        
        {/* Left Content */}
        <motion.div
          initial={{ x: -80, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="w-full lg:w-1/2 text-center lg:text-left"
        >
          <h2 className="text-[36px] md:text-[44px] font-semibold text-[#1C1C1C] leading-snug mb-6">
            Efficient hiring <br /> processes
          </h2>
          <p className="text-[16px] text-[#3D3D3D] leading-relaxed mb-4">
            Our platform revolutionizes the recruitment process by centralizing job postings,
            candidate applications, and interview scheduling. This automation not only saves
            time but also ensures that only the most suitable candidates are matched with job openings.
          </p>
          <p className="text-[16px] text-[#3D3D3D] leading-relaxed">
            Advanced algorithms streamline the process, letting providers focus on patient care.
          </p>
        </motion.div>

        {/* Right Image */}
        <motion.div
          initial={{ x: 80, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="w-full lg:w-1/2 flex justify-center"
        >
          <img
            src={wh}
            alt="World Health Day"
            className="w-full max-w-md"
          />
        </motion.div>
      </div>
    </section>

    <section className="bg-[#1c1c1c] text-white font-poppins py-20 px-4 overflow-x-hidden">
      {/* Header */}
      <div className="max-w-6xl mx-auto text-center mb-16">
        <div className="inline-block bg-black text-white text-sm font-semibold px-4 py-2 rounded-full mb-6">
          LENTERA’S INNOVATION
        </div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight mb-6">
          Revolutionizing healthcare training <br /> and recruitment
        </h1>
        <p className="text-base sm:text-[15px] text-gray-300 leading-relaxed">
          Lentera revolutionizes healthcare training and recruitment with cutting-edge tools,
          streamlining the hiring process and fostering continuous professional growth for
          enhanced operational efficiency.
        </p>
      </div>

      {/* Cards Grid */}
      <div className="max-w-[1320px] mx-auto flex flex-wrap justify-center gap-7">
        {ffeatures.map((item, index) => {
          const row = Math.floor(index / 3);
          const fromRight = row % 2 === 0;

          return (
            <motion.div
              key={index}
              initial={{ x: fromRight ? 100 : -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="bg-[#2e2e2e] rounded-[20px] px-6 py-6 flex flex-col items-start"
              style={{
                width: `${item.width}px`,
                height: `${item.height}px`,
              }}
            >
              <img src={tick} alt="tick" className="w-10 h-10 mb-4" />
             <p
  className={`text-white text-[15px] leading-relaxed text-left ${
    item.tight ? "-mt-2" : "mt-0"
  }`}
>
  {item.text}
</p>

            </motion.div>
          );
        })}
      </div>
    </section>
<section className="bg-white text-[#1c1c1c] py-20 px-6 md:px-10 lg:px-20">
  {/* Header Section */}
  <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between items-start lg:items-center mb-14">
    <div className="flex-1">
      <h2 className="font-semibold text-[42px] leading-[1.2]">
        How Lentera helps the <br className="hidden md:block" />
        healthcare sector
      </h2>
      <p className="mt-6 text-[16px] leading-[1.7] text-[#3d3d3d] max-w-[600px]">
        Lentera empowers the healthcare sector with real-time tracking and
        data-driven solutions to enhance efficiency, safety, and patient care.
      </p>
    </div>

    {/* Arrows */}
    <div className="flex gap-4 mt-8 lg:mt-0">
      <button onClick={scrollLeft}>
        <img src={l} alt="left arrow" className="w-10 h-10 rounded-full border" />
      </button>
      <button onClick={scrollRight}>
        <img src={r} alt="right arrow" className="w-10 h-10 rounded-full border" />
      </button>
    </div>
  </div>

  {/* Scrollable Cards */}
  <div className="overflow-hidden">
    <div
      ref={scrollRef}
      className="flex gap-6 overflow-x-auto scroll-smooth no-scrollbar pb-2"
    >
      {featuress.map((feature, index) => (
        <div
          key={index}
          className="min-w-[421.33px] max-w-[421.33px] bg-[#E9FFF1] rounded-[32px] p-6 flex-shrink-0"
          style={{ height: '273px' }}
        >
          <div className="flex flex-col justify-start h-full">
            <img
              src={feature.icon}
              alt={feature.title}
              className="w-12 h-12 mb-4"
            />
            <h3 className="text-[18px] font-semibold mb-2 leading-[1.4]">
              {feature.title}
            </h3>
            <p className="text-[15px] text-[#3d3d3d] leading-[1.7]">
              {feature.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>




<section className="bg-[#f9f9f9] py-20 px-6 md:px-10 lg:px-20">
  {/* Header */}
  <div className="text-center max-w-3xl mx-auto mb-14">
    <h2 className="text-4xl font-bold text-[#1c1c1c] leading-tight mb-4">
      Enhancing the quality of healthcare
    </h2>
    <p className="text-[16px] text-[#3d3d3d]">
      We empower healthcare providers with smart tools and services that
      enhance care quality and improve patient outcomes.
    </p>
  </div>

  {/* Card Grid */}
  <motion.div
    variants={container}
    initial="hidden"
    whileInView="show"
    viewport={{ once: false, amount: 0.3 }}
    className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-center items-stretch"
  >
    {featuresss.map((item, idx) => (
      <motion.div
        key={idx}
        variants={fadeInUp}
        className="w-full max-w-[640px] h-[402px] bg-white rounded-[12px] shadow-md p-6 relative overflow-hidden mx-auto"
      >
        {/* Icon Box */}
        <div
          className={`absolute top-0 left-0 w-[75px] h-[75px] rounded-br-[20px] ${item.bg} flex items-center justify-center`}
        >
          <img src={item.icon} alt={item.title} className="w-15 h-15" />
        </div>

        {/* Card Content */}
        <div className="mt-20">
          <h3 className="text-[20px] font-semibold text-[#1c1c1c] mb-3 leading-snug">
            {item.title}
          </h3>
          <p className="text-[#3d3d3d] text-[16px] leading-relaxed">
            {item.description}
          </p>
        </div>
      </motion.div>
    ))}
  </motion.div>
  

</section>



      <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
            {/* Top newsletter */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
              {/* Left Side */}
              <div className="flex items-start md:items-center gap-4 md:gap-6">
                <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                  Join our newsletter to <br className="hidden md:block" />
                  keep up to date with us!
                </h2>
              </div>

              <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                {/* Newsletter input */}
                <div
                  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                  style={{ borderRadius: "6px" }}
                >
                  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                  <input
                    type="email"
                    value={submail}
                    onChange={(e) => setSubmail(e.target.value)}
                    placeholder="Enter your email"
                    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                  />
                </div>


                {/* Captcha line (canvas + refresh + input + subscribe button) */}
                {/* Outer wrapper to center the row */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center gap-3">
                    {/* Captcha canvas */}
                    <div className="captcha-box">
                      <canvas
                        ref={newsletterCanvasRef}
                        id="newsletterCaptchaCanvas"
                        width={60}
                        height={40}
                        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                      />
                    </div>

                    {/* Refresh button */}
                    <button
                      onClick={handleReload}
                      style={{
                        background: "#07862B ",
                        color: "#fff",
                        border: "none",
                        padding: "6px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                      </svg>
                    </button>

                    {/* Captcha input */}
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={newsletterUserCaptcha}
                      onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                      className="captcha-input"
                    />

                    {/* Subscribe button */}
                    <button className="subscribe-button" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                  </div>
                </div>

                <style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>

              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 w-full" />

            {/* Main Footer Content */}
            <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
              {/* Company Info */}
              <div className="w-full lg:w-[30%]">
                <a href="/" aria-label="Lentera Home">
                  <img src={nlen} alt="Lentera logo" className="mb-6" />
                </a>
                <p className="text-[#d4d4d4] leading-relaxed">
                  We are highly experienced in offering software development, mobile
                  application development, software consulting and project management
                  delivery.
                </p>
                {/* Social Icons */}
                <div className="flex gap-4 mt-6 flex-wrap">
                  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src={inst} alt="Instagram" className="w-8 h-8" />
                  </a>
                  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                    <img src={face} alt="Facebook" className="w-8 h-8" />
                  </a>
                  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={you} alt="YouTube" className="w-8 h-8" />
                  </a>
                  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                  </a>
                  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                    <img src={twi} alt="X" className="w-8 h-8" />
                  </a>
                </div>

              </div>

              {/* Services */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                </ul>
              </div>


              {/* Insights */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><Link to="/blogs" className="hover:text-white">Blog</Link></li>
                  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                  <li><Link to="/blogs" className="hover:text-white">News</Link></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="w-full md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                <div className="flex items-start gap-3 mb-3">
                  <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Phone number</p>
                    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                      +91-44-4856-3345
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-3">
                  <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Email address</p>
                    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Location</p>
                    <a
                      href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-medium text-sm hover:underline block"
                    >
                      G1, Plot No, 824 and 826, 3rd<br />
                      Main Rd, Ram Nagar South,<br />
                      Madipakkam, Chennai,<br />
                      Tamil Nadu 600091
                    </a>
                  </div>
                </div>


              </div>
            </div>
          </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>

   

    </div>
  )
}

export default Health